import { useState } from 'react'

export const usePagination = () => {
  const [page, setPage] = useState(0)
  const [count, setCount] = useState(0)
  const [areRecordsInitialized, setRecordsInitialization] = useState(false)

  return { page, setPage, count, setCount, areRecordsInitialized, setRecordsInitialization }
}
